import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type AttendeeType from 'owa-service/lib/contract/AttendeeType';

/**
 * check if the original recipients appear in the final meeting invite (regardless of required /optional)
 */
export default function areOriginalRecipientsIncludedInMeeting(
    diffEvent: CalendarEvent,
    originalEvent: CalendarEvent
): boolean {
    // gather all original recipients smtp in an array
    let originalAttendeesSmtps: string[] = [];
    originalAttendeesSmtps = originalAttendeesSmtps.concat(
        getAttendeesSmtp(originalEvent.RequiredAttendees)
    );
    originalAttendeesSmtps = originalAttendeesSmtps.concat(
        getAttendeesSmtp(originalEvent.OptionalAttendees)
    );

    let updatedAttendeesSmtps: string[] = [];
    updatedAttendeesSmtps = updatedAttendeesSmtps.concat(
        getAttendeesSmtp(diffEvent.RequiredAttendees)
    );
    updatedAttendeesSmtps = updatedAttendeesSmtps.concat(
        getAttendeesSmtp(diffEvent.OptionalAttendees)
    );

    for (let i = 0; i < updatedAttendeesSmtps.length; i++) {
        if (!originalAttendeesSmtps.some(smtp => smtp === updatedAttendeesSmtps[i])) {
            return false;
        }
    }

    return true;
}

function getAttendeesSmtp(attendeelist: AttendeeType[]): string[] {
    const smtpList: string[] = [];

    if (attendeelist) {
        for (let i = 0; i < attendeelist.length; i++) {
            if (attendeelist[i]?.Mailbox?.EmailAddress) {
                smtpList.push(attendeelist[i].Mailbox.EmailAddress);
            }
        }
    }
    return smtpList;
}
